module.exports = __webpack_public_path__ + "img/relief_1.f5ef60e5.jpg";